
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/history",
      function () {
        return require("private-next-pages/user/history.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/history"])
      });
    }
  